var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 90,
    viewBox: "0 0 185 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.032 7.7807C175.277 10.4502 178.45 11.6052 181.12 10.3604C183.789 9.11555 184.944 5.94232 183.699 3.27277C182.454 0.603221 179.281 -0.551739 176.612 0.693088C173.942 1.93792 172.787 5.11115 174.032 7.7807ZM1.42262 89.3731L179.288 6.43304L178.443 4.62042L0.577382 87.5605L1.42262 89.3731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLine1);
export default __webpack_public_path__ + "static/media/topLine1.4c9f5861b89bc6051ee673fb9e06187c.svg";
export { ForwardRef as ReactComponent };